import { head } from 'ramda'
import React from 'react'

import { useMultiSelectState } from '../../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import { useServiceOrders } from '../_load/ServiceOrdersLoader'
import { useServiceOrdersActionsList } from '../../../../utils/actions/serviceOrders/list'
import MultiSelectMenu from '../../../../packages/kiti/components/multiSelect/MultiSelectMenu'

const MultiRowsActions = () => {
  const serviceOrders = useServiceOrders()
  const { selecteds, getSelectedData } = useMultiSelectState()
  const selectedServiceOrders = getSelectedData(serviceOrders)

  const menuOptions = useServiceOrdersActionsList(
    head(selectedServiceOrders),
    selecteds,
    selectedServiceOrders?.map(item => item.status?.name)
  )

  return <MultiSelectMenu options={menuOptions} />
}

export default MultiRowsActions
